// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2645P","header":"ReportDetails_header__UCbLu","title":"ReportDetails_title__HV7zs","left":"ReportDetails_left__-vz8G"};